import { isMetricPercent } from 'utils/metrics';
import NumberComponent from './NumberComponent';
import { NumberContainer } from './Number.styled';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /** Object containing current value and previous values. */
//   data: [{ current: number, previous: type, isPercent: boolean }],
//   /**
//    * Additional options for number.
//    * {
//    *  { Boolean } invertColors: Trend color is on text or background.
//    *  { Boolean } showSparkline: Display sparkline.
//    *  { Boolean } showTrend: Display trend.
//    *  { String } trendDirection: Direction of number trend.
//    * }
//    */
//   options: {
//     invertColors: boolean,
//     showTrend: ?boolean,
//     trendDirection: ?string,
//   },
//   /* Theme of the number chart. */
//   theme: string,
//   /** Title of the number chart. */
//   title: ?string,
// };

const defaultProps = {
  data: [],
  theme: 'default',
};

const Number = (props) => {
  const { className, data, options, title, theme } = props;
  const { invertColors } = options || { invertColors: false };

  const numbers = data.map(({ metric, name, ...numberData }, index) => (
    <NumberComponent
      key={index}
      label={name}
      options={{ ...options, isPercent: isMetricPercent(metric) }}
      theme={theme}
      {...numberData}
    />
  ));

  return (
    <NumberContainer
      className={className}
      data-quantity={Math.min(numbers.length, 3)}
      data-theme={theme}
      data-type="number"
      data-invert={!!invertColors}
    >
      {title && <div className="cssNumberTitle">{title}</div>}
      {numbers}
    </NumberContainer>
  );
};

export default Number;
Number.defaultProps = defaultProps;
